<div class="search-period" [class.search-period--open]="p?.isOpen()" [class.search-period--filled]="selected">

  <!-- field -->
  <div
    class="inner"
    [ngbPopover]="popContent"
    #p="ngbPopover"
    placement="bottom-left bottom-right"
    popoverClass="popover--search popover--search-period"
    [autoClose]="'outside'"
    (hidden)="setState(isValid())"
    >
    @if (!selected) {
      <!-- empty -->
      <span class="empty">{{placeholder}}</span>
    } @else {
      <!-- filled -->
      <span class="label">{{placeholder}}:</span>

      @if (FORM.code === 'code') {
        <!-- code -->
        <span class="value">{{selected?.title}}</span>
      } @else if (FORM.code === 'range') {
        <!-- range -->
        <span class="value">
          @if (FORM.from && !FORM.until) {
            <span class="label label--range m-l-0">van</span>
          }
          @if (FORM.from) {
            {{FORM.from | display}}
          }
          @if (FORM.until) {
            <span class="label label--range" [class.m-l-0]="!FORM.from" >tot</span>
          }
          @if (FORM.until) {
            {{FORM.until | display}}
          }
          <span class="label label--range"> jaar</span>

        </span>
      } @else if(FORM.code === 'maximum' || FORM.code === 'minimum'){
        <!-- range -->
        <span class="value">
          @if (FORM.from) {
            Min. {{FORM.from | display}} jaar
          }
          @if (FORM.until) {
            Max. {{FORM.until | display}} jaar
          }
        </span>
      } @else {
        <span class="value">
          @if (FORM.from) {
            {{FORM.from | display}} jaar
          }
        </span>
      }
    }
    <!-- icon -->
    <i class="im-icon im-icon-triangle-rounded-down"></i>
  </div>

  <!-- popover -->
  <ng-template #popContent>
    <div class="popover--inner">


      @for (option of codeOptions; track option) {
        <div class="popover-row" (click)="setSelected(option.value)">
          <div class="radio-wrap">
            <div class="fake-radio" [class.active]="option.value === selected?.value">
              <span></span>
            </div>
          </div>
          <div class="value-wrap">
            <div class="descr">{{option.title}}</div>
            @if (option.value === 'exact') {
              @if (option.value === selected?.value) {
                <div
                  class="range"
                  style="min-height: 32px;"
                  >
                  <app-field-text
                    [type]="type"
                    [instant]="type === 'integer'"
                    [model]="FORM?.from"
                    [width]="'112px'"
                    (modelChange)="FORM.from = $event; FORM.until = undefined; isValid()"
                  ></app-field-text>
                </div>
              }
            }
            @if (option.value === 'minimum') {
              @if (option.value === selected?.value) {
                <div
                  class="range"
                  style="min-height: 32px;"
                  >
                  <app-field-text
                    [type]="type"
                    [instant]="type === 'integer'"
                    [model]="FORM?.from"
                    [width]="'112px'"
                    (modelChange)="FORM.from = $event; FORM.until = undefined; isValid()"
                  ></app-field-text>
                </div>
              }
            }
            @if (option.value === 'maximum') {
              @if (option.value === selected?.value) {
                <div
                  class="range"
                  style="min-height: 32px;"
                  >
                  <app-field-text
                    [type]="type"
                    [instant]="type === 'integer'"
                    [model]="FORM?.until"
                    [width]="'112px'"
                    (modelChange)="FORM.until = $event; FORM.from = undefined; isValid()"
                  ></app-field-text>
                </div>
              }
            }
            @if (option.value === 'range') {
              @if (option.value === selected?.value) {
                <div
                  class="range"
                  style="min-height: 32px;"
                  >
                  <app-field-text
                    [type]="type"
                    [instant]="type === 'integer'"
                    [model]="FORM?.from"
                    [width]="'112px'"
                    (modelChange)="FORM.from = $event; isValid()"
                  ></app-field-text>
                  <span class="and">en</span>
                  <app-field-text
                    [type]="type"
                    [instant]="type === 'integer'"
                    [model]="FORM?.until"
                    [width]="'112px'"
                    (modelChange)="FORM.until = $event; isValid()"
                  ></app-field-text>
                </div>
              }
            }
          </div>
        </div>
      }
      <div class="clear-wrap">
        <button [disabled]="!FORM?.code" class="confirm" (click)="confirm()">Toepassen</button>
        @if (allowClear && selected) {
          <button [disabled]="!FORM?.code" class="clear" (click)="clear()">Selectie leegmaken</button>
        }
      </div>
    </div>
  </ng-template>
</div>